import { Pipe, PipeTransform } from '@angular/core';

// Display-only formatting for a stored phone number - never mutates the underlying value.
// No reliable UK/US signal is available from get_user_config_data (country/countryName are
// opaque numeric ids there), so this defaults to US formatting: 10-digit numbers (or 11 with a
// leading 1) -> (XXX) XXX-XXXX. Anything else is returned unmodified.
@Pipe({
    name: 'phoneDisplayFormat'
})
export class PhoneDisplayFormatPipe implements PipeTransform {

    transform(value: string): string {
        if (!value || typeof value !== 'string') {
            return value;
        }

        const digits = value.replace(/\D/g, '');
        const tenDigits = digits.length === 11 && digits.startsWith('1') ? digits.substring(1) : digits;

        if (tenDigits.length === 10) {
            return `(${tenDigits.substring(0, 3)}) ${tenDigits.substring(3, 6)}-${tenDigits.substring(6)}`;
        }

        return value;
     }

}
